<template>
  <div id="wrapper" v-if="project">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li>
                <router-link :to="{name: 'Projects'}">Projects</router-link>
              </li>
              <li class="active">
                <span>Project Overview</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Project Overview - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Glimpse at project content and navigate through workflow steps</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-12">
          <div class="hpanel " id="workflow-steps">
            <div class="panel-heading" >
              Workflow steps
            </div>
            <div class="panel-body">
              <breadcrumb-box :projectId="project.id" ></breadcrumb-box>
            </div>
          </div>
        </div>

      </div>

      <div class="row" style="margin-bottom: 10px">
        <div class="col-xs-12">
          <div class="hpanel" v-if="project !== null" id="project-summary">
            <div class="panel-heading">
              Summary
              <div class="panel-tools">
                <div class="btn-group">
                  <button class="btn btn-xs btn-info" @click="modalProjectAction = 'edit'"><i class="fa fa-eye"></i> Edit</button>
                </div>
              </div>
            </div>

            <div class="panel-body">
              <div class="row" style="height: 100%">
                <div class="col-sm-12 col-md-6">
                  <b>Description</b><br>
                  <div v-if="project.description" v-html="project.description" style="max-height: 100px;overflow: auto"></div>
                  <div v-else style="font-style: italic">
                    Brief project description...
                  </div>

                </div>
                <div class="col-sm-12 col-md-6 border-left border-hidden-sm">
                  <div class="row">
                    <div class="col-xs-12">
                      <label>Subproject</label>
                    </div>
                    <div class="col-xs-8">
                      <v-select2 :options="project.lists" label="title" v-model="listSelected"/>
                    </div>
                    <div class="col-xs-4 text-center">
                      <div class="dropdown ">
                        <button style="width: 100%" class="btn-outline btn btn-default dropdown-toggle" id="dropdownMenu1"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                          Actions <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu pull-left" aria-labelledby="dropdownMenu1" style="width: 100%">
                          <li>
                            <a role="button" data-toggle="modal" data-target="#modalAddList">
                              <i class="fa fa-plus text-success"></i> New Subproject
                            </a>
                          </li>
                          <template v-if="listSelected">
                            <li>
                              <a role="button" data-toggle="modal" data-target="#modalEditList">
                                <i class="fa fa-edit text-primary"></i> Rename
                              </a>
                            </li>
                            <li role="separator" class="divider"></li>
                            <li>
                              <a role="button" data-toggle="modal"  data-target="#modalDeleteList">
                                <i class="fa fa-remove text-danger"></i> Delete
                              </a>
                            </li>
                          </template>
                        </ul>
                      </div>

                    </div>
                  </div>
                  <div class="row" style="margin-top: 20px">
                    <div class="col-xs-12">
                      <span class="col-xs-4">Selected Experts</span>
                      <span class="col-xs-2 text-success bold text-left">{{authorsSelected.length}}</span>
                      <span class="col-xs-4">Similar Experts</span>
                      <span class="col-xs-2 text-warning bold text-left">{{authorsSimilar.length}}</span>
                    </div>
                    <div style="margin-top: 5px" class="col-xs-12">
                      <span class="col-xs-4">Selected Companies</span>
                      <span class="col-xs-2 text-success bold text-left">{{companiesSelected.length}}</span>
                      <span class="col-xs-4">Similar Companies</span>
                      <span class="col-xs-2 text-warning bold text-left">{{companiesSimilar.length}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="panel-footer row">
              <div class="col-xs-3">
                <label>Owner :</label>
                <template v-if="project.owner">{{project.owner.lastname}} {{project.owner.firstname}}</template>
              </div>
              <div class="col-xs-3">
                <template v-if="question && question.consultant && project.workflow_id !== 1">
                  <label>Broker :</label>
                  {{question.consultant.lastname}} {{question.consultant.firstname}}
                </template>
              </div>
              <div class="col-xs-3">
                <template>
                  <label>Portfolio :</label>
                  <span v-if="project.portfolio.length !== 0">{{project.portfolio[0].name}}</span>
                  <span v-else>none</span>
                </template>
              </div>
              <div class="col-xs-3 text-right">
                <label>Last Update :</label>
                <span>{{project.updated_at | moment('LLL')}}</span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="modalProjectAction !== null">
          <action-modal-project :project="project" v-model="modalProjectAction" :refresh="refreshProject"/>
        </template>

      </div>

      <div class="row">
        <div class="col-xs-12">
          <followed-queries :listId="listSelected === null ? null : listSelected.id" :showLimitPlan="() => {}"></followed-queries>
        </div>
      </div>

      <div class="row" v-if="project.workflow_id !== 1" style="margin-bottom: 10px">
        <div class="col-xs-12">
          <question-resume :projectId="project.id" :questionId="question ? question.id : null" :workflowId="project.workflow_id" :large="true"/>
        </div>
      </div>

      <div class="row" style="margin-bottom: 10px" id="project-biblio">
        <div class="col-xs-12">
          <biblio-box :listId="listSelected === null ? null : listSelected.id" :project="project" :height="340"></biblio-box>
        </div>
      </div>

      <div id="experts">
        <div class="row">
          <div class="col-xs-12">
            <div class="hpanel" style="margin-bottom: 0">
              <div class="panel-heading">The Experts
                <div class="panel-tools">
                  <button class="btn btn-info btn-xs" @click="addExpert()"><i class="fa fa-plus"></i> Add expert</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="hpanel">
              <list-idexlab v-if="listSelected" :project="project" :listType="'author'" :items="authorsSelected" :listId="listSelected.id"
                            :biblio="biblio" :type="'selected'" :showLimitPlan="showLimitPlan" :followedSearches.sync="followedSearches" :projectsLists="projectsLists"/>
            </div>
          </div>
        </div>

        <div class="row" v-if="authorsSimilar.length !== 0">
          <div class="col-xs-12">
            <div class="hpanel">
              <list-idexlab v-if="listSelected" :project="project" :listType="'author'" :items="authorsSimilar" :listId="listSelected.id"
                            :biblio="biblio" :type="'similar'" :showLimitPlan="showLimitPlan" :followedSearches.sync="followedSearches" :projectsLists="projectsLists"/>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <div class="hpanel" style="margin-bottom: 0px;">
              <div class="panel-heading">
                <div class="panel-tools">
                  <button class="btn btn-info btn-xs m-b-xs" @click="addCompany()"><i class="fa fa-plus"></i> Add company</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="hpanel">
              <list-idexlab v-if="listSelected" :project="project" :listType="'company'" :items="companiesSelected" :listId="listSelected.id"
                            :biblio="biblio" :type="'selected'" :showLimitPlan="showLimitPlan" :followedSearches.sync="followedSearches" :projectsLists="projectsLists"/>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div id="modalAddList" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <form v-on:submit="addList">
          <div class="modal-content">
            <div class="modal-header">
              <h3>Create new Subproject</h3>
            </div>
            <div class="modal-body">
              <div class="rows">
                <div class="form-group">
                  <label for="title" class="required">Title</label>
                  <input id="title" class="form-control" v-model="newList.title" required/>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">
                Add Subproject
              </vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="listSelected" id="modalEditList" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <form v-on:submit="editList">
          <div class="modal-content">
            <div class="modal-header">
              <h3>Edit current Subproject</h3>
            </div>
            <div class="modal-body">
              <div class="rows">
                <div class="form-group">
                  <label for="title2" class="required">Title</label>
                  <input id="title2" class="form-control" v-model="listSelected.title" required/>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-default" data-dismiss="modal" aria-hidden="true">Cancel</button>
              <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">
                Save Changes
              </vue-ladda>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div v-if="listSelected" id="modalDeleteList" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="color-line"></div>
          <div class="modal-header">
            <h4 class="modal-title">Delete Subproject</h4>
          </div>
          <div class="modal-body">
            <h3>Are you sure you want to delete this Subproject: {{listSelected.title}}?</h3>
            <div>
              <span>Deleting a Subproject is irreversible and also deletes the corresponding Biblio</span>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
            <vue-ladda type="submit" :loading="submit.loading" class="btn btn-danger" :data-style="submit.dataStyle" v-on:click="removeListSelected">Delete List & Biblio</vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>

    <add-author v-model="expertToAdd" :list-selected="listSelected" v-if="expertToAdd && listSelected"></add-author>
    <add-company v-model="companyToAdd" :list-selected="listSelected" v-if="companyToAdd && listSelected"></add-company>

  </div>

</template>

<script>
import BiblioBox from '../../components/biblio/BiblioBox'
import QuestionResume from '../../components/question/QuestionResume'
import ActionModalAssignedToConsultant from '../../components/project/ActionModalAssignedToConsultant'
import VueLadda from 'vue-ladda'
import ActionModalProject from '../../components/project/ActionModalProject'
import ListAuthors from '../../components/ListAuthors/ListAuthors'
import ListCompanies from '../../components/ListCompanies/ListCompanies'
import BreadcrumbBox from '../../components/project/BreadcrumbBox'
import vSelect2 from '../../components/utils/select2'
import ListIdexlab from '../../components/ListIdexlab/ListIdexlab'
import LimitPlan from '../../components/LimitPlan'
import AddAuthor from '../../components/modal/AddAuthor'
import AddCompany from '../../components/modal/AddCompany'
import FollowedQueries from '../../components/Dashboard/FollowedQueries'

export default {
  components: {
    FollowedQueries,
    AddCompany,
    ListIdexlab,
    ListCompanies,
    ListAuthors,
    ActionModalProject,
    QuestionResume,
    BiblioBox,
    VueLadda,
    ActionModalAssignedToConsultant,
    BreadcrumbBox,
    vSelect2,
    LimitPlan,
    AddAuthor
  },
  props: [],
  name: 'ProjectDetails',
  watch: {
    listSelected: function (list) {
      if (list !== null) {
        this.$eventHub.$emit('listIdSelected', list.id)
        this.getLists()
        this.getFollowedSearches()
        localStorage.setItem('listIdSelected', list.id)
      }
    }
  },
  methods: {
    getResources: function () {
      this.getProjectDetails()
    },
    getProjectDetails () {
      this.axios.get('/project/' + this.projectId + '?relations={portfolio,workflow,question,lists,lists.biblio,owner,question.consultant}')
        .then((response) => {
          this.project = response.data
          this.question = this.project.question
          this.setListSelected(null)
          this.$route.meta.workflow_id = this.project.workflow_id ? this.project.workflow_id : 2
          this.startTakeTour()
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    getProjectsLists () {
      this.axios.get('/user/' + this.$auth.user().id + '/projects')
        .then((response) => {
          this.projectsLists = response.data
        }).catch((error) => {
          if (error.response.status === 403) {
            this.$router.replace({name: 'Error403', params: {'0': ''}})
          }
          if (error.response.status === 404) {
            this.$router.replace({name: 'Error404', params: {'0': ''}})
          }
        })
    },
    getCompanyAuthors: function () {
      if (this.listIdSelected !== null) {
        this.axios.get('/list/' + this.listSelected.id + '?relations={companyAuthors}')
          .then((response) => {
            this.authorsSelected = response.data.company_authors.authors_selected
            this.authorsSimilar = response.data.company_authors.authors_similar
            this.companiesSelected = response.data.company_authors.companies_selected
            this.companiesSimilar = response.data.company_authors.companies_similar
          })
          .catch(() => {
          })
      }
    },
    getLists: function () {
      this.getCompanyAuthors()
      this.getProjectsLists()
    },
    addList: function (e) {
      e.preventDefault()
      this.submit.loading = true

      if (this.newList.title !== null) {
        this.axios.post('/list/?relations={biblio}', {
          project_id: this.project.id,
          title: this.newList.title,
          biblio_id: (this.listSelected !== null && this.listSelected.biblio.length !== 0)
            ? this.listSelected.biblio[0].id : null
        })
          .then((response) => {
            this.listSelected = response.data
            this.getResources()

            this.$notify({
              type: 'success',
              title: 'New Subproject added',
              placement: 'bottom-right'
            })

            this.getProjectsLists()
            this.$salesMachine.createList({list: this.newList.title})
            this.newList.title = null

          }).finally(() => {
            $('#modalAddList').modal('hide')
            this.submit.loading = false
          })
      }
    },
    editList: function (e) {
      e.preventDefault()
      if (this.listSelected !== null) {
        this.submit.loading = true

        this.axios.patch('/list/' + this.listSelected.id, {
          title: this.listSelected.title
        })
          .then((response) => {
            this.getResources()
            this.setListSelected(response.data)

            this.$notify({
              type: 'success',
              title: 'List modified',
              placement: 'bottom-right'
            })
          })
          .finally(() => {
            $('#modalEditList').modal('hide')
            this.submit.loading = false
          })
      }
    },
    setListSelected: function (listSelected = null) {
      this.listSelected = null

      this.listSelected = listSelected

      if (listSelected === null) {
        let listIdSelected = parseInt(localStorage.getItem('listIdSelected'))

        if (typeof listIdSelected !== 'undefined' && listIdSelected !== null && this.project.lists.length !== 0) {
          this.listSelected = this.project.lists.find((list) => {
            return list.id === listIdSelected
          })

          if (typeof this.listSelected === 'undefined') {
            this.listSelected = null
          }
        }
      }

      if (this.listSelected === null && this.project.lists.length !== 0) {
        this.listSelected = this.project.lists[0]
      }
    },
    removeListSelected: function (e) {
      e.preventDefault()

      if (this.listSelected !== null) {
        this.axios.delete('/list/' + this.listSelected.id + '/project/' + this.project.id)
          .then((response) => {
            this.setListSelected(null)
            this.getResources()

            this.$notify({
              type: 'success',
              title: 'List deleted',
              placement: 'bottom-right'
            })
          })

          .finally(() => {
            $('#modalDeleteList').modal('hide')
            this.submit.loading = false
          })
      }
    },
    refreshProject: function () {
      this.getProjectDetails()
    },
    showLimitPlan: function (action) {
      this.$refs.limitPlan.show(action)
    },
    startTakeTour: function () {
      if (this.project !== null) {
        this.$eventHub.$emit('startTour', true)
      }
    },
    addExpert: function () {
      this.expertToAdd = {
        firstName: null,
        lastName: null,
        author_organisations: [{
          organisation: {
            organisationName: null
          },
          email: null
        }]
      }
      setTimeout(() => {
        $('#modalAddExpert').modal('show')
      }, 2000)
    },
    addCompany: function () {
      this.companyToAdd = {
        firstName: null,
        lastName: null,
        author_organisations: [{
          organisation: {
            organisationName: null,
            phone: null,
            country: null,
            description: null,
            website: null
          },
          email: null
        }]
      }
      setTimeout(() => {
        $('#modalAddCompany').modal('show')
      }, 2000)
    },
    getFollowedSearches: function () {
      let url = 'follow/search/' + (this.listSelected !== null ? this.listSelected.id : '')

      this.axios.get(url).then((response) => {
        this.followedSearches = response.data
      }).catch((error) => {

      })
    }
  },
  data () {
    return {
      projectId: null,
      project: null,
      question: null,
      listSelected: null,
      authorsSelected: [],
      authorsSimilar: [],
      companiesSelected: [],
      companiesSimilar: [],
      followedSearches: [],
      projectsLists: [],
      biblio: null,
      apiLink: process.env.API_URL,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      newList: {
        title: null
      },
      modalProjectAction: null,
      mounted: false,
      expertToAdd: null,
      companyToAdd: null
    }
  },
  beforeMount () {
    this.projectId = parseInt(this.$route.params.id)
    localStorage.setItem('projectSelected', this.projectId)

    this.$eventHub.$on('biblioSelected', (biblio) => {
      this.biblio = biblio
    })

    this.$eventHub.$on('updateCompanyAuthorList', (tmp) => {
      this.getLists()
    })
    this.getProjectsLists()
    this.getResources()
  },
  mounted () {
    this.mounted = true
  },
  beforeDestroy () {
    this.$eventHub.$off('biblioSelected')
    this.$eventHub.$off('updateCompanyAuthorList')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/project/ProjectDetails.vue